export const Bet_History_Filter = Object.freeze({
    Win: 'Win',
    Loss: 'Loss'
})